import { useAuth0 } from '@auth0/auth0-react';
import { useMockAuth0 } from '../mock-auth';

/**
 * Custom hook that provides the appropriate Auth0 context based on environment.
 * Uses mock authentication when REACT_APP_DISABLE_AUTH=true AND NODE_ENV=development, otherwise uses real Auth0.
 * This ensures auth bypass only works in development for security.
 */
export function useAppAuth () {
  const SKIP_AUTH = process.env.NODE_ENV === 'development' && process.env.REACT_APP_DISABLE_AUTH === 'true';
  const auth0 = useAuth0();
  const mockAuth = useMockAuth0();

  return SKIP_AUTH ? mockAuth : auth0;
}
